module.exports = __webpack_public_path__ + "static/media/mtl-transfer-factors.282268bf.ipynb";